export default __webpack_public_path__ + "static/Plots0012-86430af9dff9fec8e4b8ca832ca83be3.jpg";